import { Button, Card, CardContent, Chip, List, ListItemButton, ListItemIcon, ListItemText, MenuItem, MenuList, Popover, Stack, Typography } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import { useIsMobile } from "../hooks/use-is-mobile";
import { MobileBottomSheet } from "./mobile/mobile-bottom-sheet";

const MobilePopOverSheet = ({ open, onClose, popoverItems, from, to, handleBodyChange, title }) => (
    <MobileBottomSheet
        open={open}
        onClose={onClose}
        title={title || (from ? "Filter by date" : "Choose an option")}
        footer={from &&
            <Button fullWidth size="large" variant="contained" onClick={onClose}>
                Done
            </Button>
        }
    >
        {popoverItems && from &&
            <>
                <Typography variant="overline" color="text.secondary" sx={{ fontWeight: 700 }}>
                    Quick ranges
                </Typography>
                <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 1, mt: 0.5 }}>
                    {popoverItems.map((item, index) => (
                        <Chip
                            key={index}
                            label={item.label}
                            variant="outlined"
                            clickable
                            onClick={() => {
                                item.onClick && item.onClick()
                                onClose()
                            }}
                        />
                    ))}
                </Stack>
                <Typography variant="overline" color="text.secondary" component="p" sx={{ fontWeight: 700, mt: 2 }}>
                    Custom range
                </Typography>
            </>
        }
        {popoverItems && !from &&
            <List disablePadding>
                {popoverItems.map((item, index) => (
                    <ListItemButton
                        key={index}
                        onClick={() => {
                            item.onClick && item.onClick()
                            onClose()
                        }}
                        sx={{ borderRadius: 2, py: 1.5, minHeight: 52 }}
                    >
                        {item.icon && <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>}
                        <ListItemText primary={item.label} primaryTypographyProps={{ fontWeight: 500 }} />
                    </ListItemButton>
                ))}
            </List>
        }
        {from &&
            <Stack spacing={2} sx={{ pt: 1 }}>
                <DateTimePicker
                    label={"From"}
                    value={from}
                    onChange={(newValue) => {
                        handleBodyChange(newValue, "from")
                    }}
                    slotProps={{ textField: { fullWidth: true } }}
                />
                <DateTimePicker
                    label={"To"}
                    value={to}
                    onChange={(newValue) => {
                        handleBodyChange(newValue, "to")
                    }}
                    slotProps={{ textField: { fullWidth: true } }}
                />
            </Stack>
        }
    </MobileBottomSheet>
)

export const CustomPopOver = (props) => {
    const { anchorEl, onClose, open, id, popoverItems, from, to, handleBodyChange } = props;
    const isMobile = useIsMobile();

    if (isMobile) {
        return <MobilePopOverSheet {...props} />;
    }

    return (
        <Popover
            id={id}
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            anchorOrigin={{
                horizontal: 'left',
                vertical: 'bottom'
            }}
            PaperProps={{
                sx: {
                    maxWidth: '500px'
                }
            }}
        >
            {popoverItems &&
                <MenuList
                    disablePadding
                    sx={{
                        '& > *': {
                            padding: '12px 16px'
                        }
                    }}
                >
                    {popoverItems?.map((item, index) => (
                        <MenuItem
                            key={index}
                            onClick={() => {
                                item.onClick && item.onClick()
                                onClose()
                            }}
                        >
                            {item.icon &&
                                <ListItemIcon>
                                    {item.icon}
                                </ListItemIcon>
                            }
                            <Typography variant="inherit" noWrap>
                                {item.label}
                            </Typography>
                        </MenuItem>
                    ))}
                </MenuList>
            }
            {from &&
                <Card>
                    <CardContent
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <DateTimePicker
                            label={"From"}
                            sx={{ mr: 1 }}
                            value={from}
                            onChange={(newValue) => {
                                handleBodyChange(newValue, "from")
                            }}
                        />
                        <DateTimePicker
                            label={"To"}
                            value={to}
                            onChange={(newValue) => {
                                handleBodyChange(newValue, "to")
                            }}
                        />
                    </CardContent>
                </Card>
            }
        </Popover>
    );
}
